import React, { Component, useState, useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import RedAsset from './images/redassetmegawide.PNG'
import MegawideLogo from './images/mwm_logo.jpg'
import NonPoModal from './components/nonpoitems/NonPoModal'
import { AzureAD, LoginType, AuthenticationState } from 'react-aad-msal'
import { authProvider } from './authProvider'
import axios from 'axios'
import ADButton from './components/ADButton/adButton'
import Backdrop from './components/controlledBackdrop/backdrop'
// import FileDownload from 'js-file-download'
// import json2csv from 'json2csv'
// const convertToCSV = json2csv.parse
// import { CrfContext } from './CrfContext'

export default function Landingpage(props) {
  const [backdropState, setBackdropState] = useState(false)
  // useEffect(() => {
  //   axios({
  //     method: 'GET',
  //     url: `http://192.168.7.76:3000/spreadsheet/glAccount`,
  //     headers: {
  //       'Api-Key':
  //         '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130'
  //     }
  //   }).then(res => {
  //     const jsonObj = []
  //     const { data } = res.data
  //     for (const obj of data) {
  //       jsonObj.push({ centerCode: obj.centerCode, centerName: obj.centerName })
  //     }
  //     FileDownload(JSON.stringify(jsonObj), `glAccountsToday.json`)
  //   })
  // }, [])
  const verifyUser = (token, logout) => {
    setBackdropState(true)
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => {
          
        const { data } = response.data
        if (data) {
          localStorage.setItem('token', token)
          window.location.reload()
        }
      })
      .catch(error => {
          
        const { data } = error.response
        if (data.error !== 'jwt expired') {
          alert(
            'The user is not yet registered in the app. Please contact your system admin for support.'
          )
        }
        logout()
      })
  }
  const loginContent = login => (
    <React.Fragment>
      <NonPoModal />
      <Backdrop open={backdropState} />
      <div className='login-page'>
        <div className='login-page-contents'>
          <img className='login-page-megawidelogo' src={MegawideLogo} alt='' />
          <h2 className='login-page-title'>
            CHECK REQUEST <br />
            AND INQUIRY SYSTEM{' '}
          </h2>
          <div className='login-title-redline'></div>
          <h4
            style={{
              left: '30rem',
              top: '-.9rem',
              position: 'relative'
            }}
          >
            Version 2.0
          </h4>
          <div className='loginContainer'>
            <div className='signin-content'>
              <h5>Sign-In</h5>
              <p id='loginValidator' />
              <ADButton onClick={login} />
            </div>
          </div>
          <img className='redAssetImg' src={RedAsset} alt='' />
        </div>
      </div>
    </React.Fragment>
  )
  return (
    <AzureAD provider={authProvider}>
      {({ login, logout, authenticationState, accountInfo }) => {
        const isInProgress =
          authenticationState === AuthenticationState.InProgress
        const isAuthenticated =
          authenticationState === AuthenticationState.Authenticated
        const isUnauthenticated =
          authenticationState === AuthenticationState.Unauthenticated

        if (isAuthenticated) {
          if (localStorage.token) {
            return (
              <Redirect
                to={{
                  pathname: '/'
                }}
              />
            )
          } else {
            verifyUser(accountInfo.jwtIdToken, logout)
            return loginContent(login)
          }
        } else if (isUnauthenticated || isInProgress) {
          if (localStorage.token) {
            localStorage.removeItem('token')
          }
          return loginContent(login)
        }
      }}
    </AzureAD>
  )
}
